import {getThemeSSRValue as sourceGetThemeSSRValue, Provider, useTheme as sourceUseTheme} from "@/components/theme/ThemeStore";
import {GetStaticPropsContext} from "next/types";

export type BaseThemeProps = {
	theme: string;
	themes: string[];
	defaultTheme: string;
	setTheme: (theme: string) => void;
}

export const getThemeSSRValue = (ctx: GetStaticPropsContext | any): string | null => {
	return sourceGetThemeSSRValue(ctx);
}

export const useTheme = (): BaseThemeProps => {
	const themeContext = sourceUseTheme();

	return {
		...themeContext
	};
}


// provider
export const ThemeProvider = (props: { children: React.ReactNode } & BaseThemeProps) => {
	return <Provider {...props}>
		{props.children}
	</Provider>
}